var map = {
	"./contact/CreateItemComponent": 966,
	"./cpo/CreateItemComponent": 967,
	"./customer/CreateItemComponent": 968,
	"./forwarderPo/CreateItemComponent": 969,
	"./incomingInvoice/CreateItemComponent": 970,
	"./incomingPayment/CreateItemComponent": 971,
	"./outgoingInvoice/CreateItemComponent": 972,
	"./outgoingPayment/CreateItemComponent": 1102,
	"./outgoingQuote/CreateItemComponent": 973,
	"./product/CreateItemComponent": 974,
	"./receiving/CreateItemComponent": 975,
	"./shipping/CreateItemComponent": 976,
	"./spo/CreateItemComponent": 977,
	"./spoSched/CreateItemComponent": 978,
	"./vatDeductRecord/CreateItemComponent": 979,
	"./vendor/CreateItemComponent": 980
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 965;